import { render } from "./UpdateWriteOff.vue?vue&type=template&id=2493c1da&scoped=true&ts=true"
import script from "./UpdateWriteOff.vue?vue&type=script&lang=ts"
export * from "./UpdateWriteOff.vue?vue&type=script&lang=ts"

import "./UpdateWriteOff.vue?vue&type=style&index=0&id=2493c1da&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2493c1da"]])

export default __exports__